export enum DismissibleHolidayNames {
  Anzac = 'Anzac Day',
}

export const STATES: { [abreviation: string]: string } = {
  NSW: 'NSW',
  VIC: 'VIC',
  QLD: 'QLD',
  WA: 'WA',
  ACT: 'ACT',
  SA: 'SA',
  NT: 'NT',
  TAS: 'TAS',
};

// TODO: use enum
type State =
  | typeof STATES.NSW
  | typeof STATES.VIC
  | typeof STATES.QLD
  | typeof STATES.WA
  | typeof STATES.ACT
  | typeof STATES.SA
  | typeof STATES.NT
  | typeof STATES.TAS;

type PublicHoliday = {
  title: string;
  message: string;
  states: State[];
  dates: Date[];
  excludedSupplierIds: number[];
  dismissibleGroupId: DismissibleHolidayNames;
};

type CustomCutoff = {
  supplierId: number;
  deliveryDate: Date;
  cutoffDateTime: Date;
};

export const PUBLIC_HOLIDAYS: PublicHoliday[] = [
  // 25 April 2024 ANZAC Day
  {
    dismissibleGroupId: DismissibleHolidayNames.Anzac,
    title: 'Anzac Day 2024',
    message: "Most suppliers won't be delivering on Anzac Day, April 25.",
    states: [STATES.NSW, STATES.VIC],
    dates: [new Date('April 25, 2024')],
    excludedSupplierIds: [471, 589],
  },
];

export const CUSTOM_CUTOFFS_FOR_DATES: CustomCutoff[] = [
  // 26 April 2024 (day after Anzac Day)
  {
    supplierId: 192,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('23 April, 2024 23:00'),
  },
  {
    supplierId: 282,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('23 April, 2024 18:00'),
  },
  {
    supplierId: 341,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 356,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('23 April, 2024 11:00'),
  },
  {
    supplierId: 388,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 431,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 14:00'),
  },
  {
    supplierId: 442,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 16:00'),
  },
  {
    supplierId: 451,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('23 April, 2024 18:00'),
  },
  {
    supplierId: 458,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('23 April, 2024 23:00'),
  },
  {
    supplierId: 464,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 465,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 468,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 14:00'),
  },
  {
    supplierId: 473,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 497,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 16:00'),
  },
  {
    supplierId: 502,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('23 April, 2024 12:00'),
  },
  {
    supplierId: 512,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 516,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 14:00'),
  },
  {
    supplierId: 518,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 519,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 14:00'),
  },
  {
    supplierId: 524,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 14:00'),
  },
  {
    supplierId: 525,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 15:00'),
  },
  {
    supplierId: 538,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 16:00'),
  },
  {
    supplierId: 543,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 09:00'),
  },
  {
    supplierId: 548,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 16:00'),
  },
  {
    supplierId: 573,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 11:00'),
  },
  {
    supplierId: 582,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('24 April, 2024 14:00'),
  },
  {
    supplierId: 589,
    deliveryDate: new Date('26 April, 2024'),
    cutoffDateTime: new Date('23 April, 2024 16:00'),
  },
];

/*
 * This array is used to determine if we should display the banner on a suppliers
 * page. We probably only want to add block-periods of public holidays here.
 */
export const SUPPLIER_HOLIDAY_DATES: Date[] = [new Date('April 25, 2024')];
